import React, { memo } from 'react';
import { NodeProps, NodeResizer, useReactFlow } from 'reactflow';
import { Lock } from 'lucide-react';
import { GroupNodeData } from '../../types';

const GroupNode = ({ id, data, selected }: NodeProps<GroupNodeData>) => {
  const { setNodes } = useReactFlow();

  const handleLabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLabel = e.target.value;
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === id) {
          return {
            ...node,
            data: { ...node.data, label: newLabel },
          };
        }
        return node;
      })
    );
  };

  const handleFocus = () => {
    if (data.onSnapshot) {
      data.onSnapshot();
    }
  };

  return (
    <>
      <NodeResizer
        minWidth={100}
        minHeight={100}
        isVisible={selected}
        lineClassName="border-primary"
        handleClassName="h-3 w-3 bg-primary border-2 border-white rounded"
      />
      <div
        className={`
        w-full h-full border-2 border-dashed rounded-none transition-colors relative group
        ${selected ? 'border-primary/50 bg-primary/5' : 'border-border/30 bg-muted/20 dark:border-border/50 dark:bg-card/20'}
      `}
      >
        {data.locked && (
          <div className="absolute -top-2 -right-2 w-5 h-5 bg-amber-400 dark:bg-amber-500 rounded-full flex items-center justify-center shadow-sm z-10">
            <Lock className="w-3 h-3 text-white" />
          </div>
        )}
        <div className="absolute -top-3.5 left-4 px-1 transition-colors bg-muted dark:bg-card">
          <input
            className="bg-transparent text-xs font-bold uppercase tracking-wider border-none focus:outline-none focus:text-primary transition-colors w-32 text-muted-foreground placeholder:text-muted-foreground dark:text-muted-foreground dark:placeholder:text-muted-foreground"
            value={data.label}
            onChange={handleLabelChange}
            onFocus={handleFocus}
            placeholder="GROUP NAME"
            onKeyDown={(e) => e.stopPropagation()}
          />
        </div>
      </div>
    </>
  );
};

export default memo(GroupNode);

